module.exports = __webpack_public_path__ + "img/non-Attempted.f0d62bf0.svg";